const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22895_58789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22895_58789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -1,
    width: 34,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.58984 -0.444336H28.5953V24.4446H-4.58984V-0.444336Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22895_58789)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.58594 -0.444336H28.5993V24.4446H-4.58594V-0.444336Z",
    fill: "#F7FCFF",
    style: {
      fill: "#F7FCFF",
      fill: "color(display-p3 0.9686 0.9882 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.58594 -0.444336V7.85196H28.5993V-0.444336H-4.58594Z",
    fill: "#E31D1C",
    style: {
      fill: "#E31D1C",
      fill: "color(display-p3 0.8902 0.1137 0.1098)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.58594 16.1484V24.4447H28.5993V16.1484H-4.58594Z",
    fill: "#3D58DB",
    style: {
      fill: "#3D58DB",
      fill: "color(display-p3 0.2392 0.3451 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4141 9.92589L-4.58594 -2.51855V26.5185L11.4141 14.074H28.5993V9.92589H11.4141Z",
    fill: "#5EAA22",
    style: {
      fill: "#5EAA22",
      fill: "color(display-p3 0.3686 0.6667 0.1333)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22895_58789",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: -8,
    width: 38,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.66016 -7.7041H30.6732V31.7033H-6.66016V-7.7041Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4141 9.92589L-4.58594 -2.51855V26.5185L11.4141 14.074H28.5993V9.92589H11.4141Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22895_58789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.58608 -2.51903L-3.31273 -4.1562L-6.66016 -6.75977V-2.51903H-4.58608ZM11.4139 9.92541L10.1406 11.5626L10.7023 11.9995H11.4139V9.92541ZM-4.58608 26.518H-6.66016V30.7588L-3.31273 28.1552L-4.58608 26.518ZM11.4139 14.0736V11.9995H10.7023L10.1406 12.4364L11.4139 14.0736ZM28.5991 14.0736V16.1476H30.6732V14.0736H28.5991ZM28.5991 9.92541H30.6732V7.85134H28.5991V9.92541ZM-5.85944 -0.881856L10.1406 11.5626L12.6873 8.28824L-3.31273 -4.1562L-5.85944 -0.881856ZM-2.51201 26.518V-2.51903H-6.66016V26.518H-2.51201ZM10.1406 12.4364L-5.85944 24.8808L-3.31273 28.1552L12.6873 15.7107L10.1406 12.4364ZM28.5991 11.9995H11.4139V16.1476H28.5991V11.9995ZM26.525 9.92541V14.0736H30.6732V9.92541H26.525ZM11.4139 11.9995H28.5991V7.85134H11.4139V11.9995Z",
    fill: "#F7FCFF",
    style: {
      fill: "#F7FCFF",
      fill: "color(display-p3 0.9686 0.9882 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3.96574 4.94757L-5.625 3.70312V5.7772V18.2216V20.2957L-3.96574 19.0513L4.33056 12.8291L5.43673 11.9994L4.33056 11.1698L-3.96574 4.94757Z",
    fill: "#272727",
    stroke: "#FECA00",
    style: {
      fill: "#272727",
      fill: "color(display-p3 0.1529 0.1529 0.1529)",
      fillOpacity: 1,
      stroke: "#FECA00",
      stroke: "color(display-p3 0.9961 0.7922 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2.33333
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22895_58789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/southAfrica.e712bc14631db38634fe25dec081e033.svg";
export { ForwardRef as ReactComponent };